exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".border{border:2px solid green}.resume-view__nav{margin-top:-3vh}.resume-nav{color:#000}@media only screen and (max-width:400px){.resume-view__nav .btn__content span{display:none}.resume-view__nav .btn{min-width:10px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f8d4aea","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/Resume.vue
// module id = 397
// module chunks = 0